"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const updatePageControlByInfo_1 = __importDefault(require("./updatePageControlByInfo"));
const updatePageTopNavControl_1 = __importDefault(require("./updatePageTopNavControl"));
const updateControlsArrayByPath_1 = __importDefault(require("./updateControlsArrayByPath"));
const addUpdatedControlsToFlattedControls_1 = __importDefault(require("./addUpdatedControlsToFlattedControls"));
const controlComputeIsDynamicLoadingFlagAfterUpdate_1 = __importDefault(require("../../shared/controlComputeIsDynamicLoadingFlagAfterUpdate"));
const updateControlById = ({ // eslint-disable-line
buildOrders, flattedControls, controlId, dataToUpdate, functionsToUpdate, shouldNotResetDynamicLoadingEnabled, }) => {
    var _a, _b, _c, _d;
    const controlInfo = flattedControls[controlId];
    if (!controlInfo) {
        throw new Error(`Control with id ${controlId} not found`);
    }
    const newBuildOrders = Object.assign({}, buildOrders);
    if (functionsToUpdate) {
        // Functions are being updated
        newBuildOrders.functions = functionsToUpdate;
    }
    switch (controlInfo.context.type) {
        case 'isPage': {
            const castedControlInfo = controlInfo;
            const { control: page } = castedControlInfo;
            const newPage = Object.assign(Object.assign(Object.assign({}, page), { isDynamicLoadingEnabled: (0, controlComputeIsDynamicLoadingFlagAfterUpdate_1.default)({
                    original: page.isDynamicLoadingEnabled,
                    shouldNotResetDynamicLoadingEnabled,
                }) }), dataToUpdate);
            return {
                buildOrders: Object.assign(Object.assign({}, newBuildOrders), { pages: Object.assign(Object.assign({}, newBuildOrders.pages), { [controlId]: newPage }) }),
                flattedControls: Object.assign(Object.assign({}, flattedControls), { [controlId]: Object.assign(Object.assign({}, castedControlInfo), { control: newPage }) }),
            };
        }
        case 'pageControl': {
            const castedControlInfo = controlInfo;
            const { pages, updatedPageId, updatedControls } = (0, updatePageControlByInfo_1.default)({
                pages: buildOrders.pages || {},
                controlInfo: castedControlInfo,
                dataToUpdate,
                shouldNotResetDynamicLoadingEnabled,
            });
            const updatedPage = pages[updatedPageId];
            if (!updatedPage) {
                throw new Error('No updated page found');
            }
            newBuildOrders.pages = pages;
            const newFlattedControls = (0, addUpdatedControlsToFlattedControls_1.default)(updatedControls, flattedControls);
            const pageInfo = newFlattedControls[updatedPageId];
            if (!pageInfo) {
                throw new Error('No page found');
            }
            return {
                buildOrders: newBuildOrders,
                flattedControls: Object.assign(Object.assign({}, newFlattedControls), { [updatedPageId]: Object.assign(Object.assign({}, pageInfo), { control: updatedPage }) }),
            };
        }
        case 'sideMenu': {
            const castedControlInfo = controlInfo;
            const newSideMenu = Object.assign(Object.assign(Object.assign({}, ((_a = newBuildOrders.menus) === null || _a === void 0 ? void 0 : _a.sideMenu) || {}), { isDynamicLoadingEnabled: (0, controlComputeIsDynamicLoadingFlagAfterUpdate_1.default)({
                    original: (_c = (_b = newBuildOrders.menus) === null || _b === void 0 ? void 0 : _b.sideMenu) === null || _c === void 0 ? void 0 : _c.isDynamicLoadingEnabled,
                    shouldNotResetDynamicLoadingEnabled,
                }) }), dataToUpdate);
            return {
                buildOrders: Object.assign(Object.assign({}, newBuildOrders), { menus: Object.assign(Object.assign({}, newBuildOrders.menus), { sideMenu: newSideMenu }) }),
                flattedControls: Object.assign(Object.assign({}, flattedControls), { [controlId]: Object.assign(Object.assign({}, castedControlInfo), { control: newSideMenu }) }),
            };
        }
        case 'isBottomMenuSheet': {
            const castedControlInfo = controlInfo;
            const { control: bottomMenuSheet, context: { pageId } } = castedControlInfo;
            if (!newBuildOrders.pages) {
                throw new Error('the build order has no pages to search for a bottom menu');
            }
            const page = newBuildOrders.pages[pageId];
            if (!page) {
                throw new Error('No page found');
            }
            const pageInfo = flattedControls[pageId];
            if (!pageInfo) {
                throw new Error(`No page info found [${pageId}]`);
            }
            const newBottomMenuSheet = Object.assign(Object.assign(Object.assign({}, bottomMenuSheet), { isDynamicLoadingEnabled: (0, controlComputeIsDynamicLoadingFlagAfterUpdate_1.default)({
                    original: bottomMenuSheet.isDynamicLoadingEnabled,
                    shouldNotResetDynamicLoadingEnabled,
                }) }), dataToUpdate);
            return {
                buildOrders: Object.assign(Object.assign({}, newBuildOrders), { pages: Object.assign(Object.assign({}, newBuildOrders.pages), { [pageId]: Object.assign(Object.assign({}, page), { bottomMenuSheet: newBottomMenuSheet }) }) }),
                flattedControls: Object.assign(Object.assign({}, flattedControls), { [pageId]: Object.assign(Object.assign({}, pageInfo), { control: Object.assign(Object.assign({}, page), { bottomMenuSheet: newBottomMenuSheet }) }), [controlId]: Object.assign(Object.assign({}, castedControlInfo), { control: newBottomMenuSheet }) }),
            };
        }
        case 'pageBottomMenuSheetControl': {
            const castedControlInfo = controlInfo;
            const { context: { pageId } } = castedControlInfo;
            if (!newBuildOrders.pages) {
                throw new Error('the build order has no pages to search for a bottom menu control');
            }
            const bottomMenuPage = newBuildOrders.pages[pageId];
            if (!bottomMenuPage) {
                throw new Error(`No page found ${pageId}`);
            }
            if (!bottomMenuPage.bottomMenuSheet) {
                throw new Error('The Page has no bottom menu');
            }
            const { controls, updatedControls } = (0, updateControlsArrayByPath_1.default)({
                controls: bottomMenuPage.bottomMenuSheet.controls || [],
                path: castedControlInfo.path,
                dataToUpdate,
                shouldNotResetDynamicLoadingEnabled,
            });
            const newBottomMenuSheet = Object.assign(Object.assign({}, bottomMenuPage.bottomMenuSheet), { controls });
            const newFlattedControls = (0, addUpdatedControlsToFlattedControls_1.default)(updatedControls, flattedControls);
            const pageInfo = newFlattedControls[pageId];
            if (!pageInfo) {
                throw new Error('Page info not found');
            }
            const newPageInfoControl = Object.assign(Object.assign({}, pageInfo.control), { bottomMenuSheet: newBottomMenuSheet });
            const newBottomMenuInfo = newFlattedControls[newBottomMenuSheet.id];
            if (!newBottomMenuInfo) {
                throw new Error('No new bottom menu info found');
            }
            return {
                buildOrders: Object.assign(Object.assign({}, newBuildOrders), { pages: Object.assign(Object.assign({}, newBuildOrders.pages), { [pageId]: Object.assign(Object.assign({}, bottomMenuPage), { bottomMenuSheet: newBottomMenuSheet }) }) }),
                flattedControls: Object.assign(Object.assign({}, newFlattedControls), { [pageId]: Object.assign(Object.assign({}, pageInfo), { control: Object.assign(Object.assign({}, newPageInfoControl), { bottomMenuSheet: newBottomMenuSheet }) }), [newBottomMenuSheet.id]: Object.assign(Object.assign({}, newBottomMenuInfo), { control: newBottomMenuSheet }) }),
            };
        }
        case 'isPageTopNavBar': {
            const castedControlInfo = controlInfo;
            const { control: topNavigationBar, context: { pageId } } = castedControlInfo;
            const topNavBarPage = newBuildOrders.pages && newBuildOrders.pages[pageId];
            if (!topNavBarPage) {
                throw new Error('No page found');
            }
            const pageInfo = flattedControls[pageId];
            if (!pageInfo) {
                throw new Error('No page info found');
            }
            const newTopNavigationBar = Object.assign(Object.assign(Object.assign({}, topNavigationBar), { isDynamicLoadingEnabled: (0, controlComputeIsDynamicLoadingFlagAfterUpdate_1.default)({
                    original: topNavigationBar.isDynamicLoadingEnabled,
                    shouldNotResetDynamicLoadingEnabled,
                }) }), dataToUpdate);
            return {
                buildOrders: Object.assign(Object.assign({}, newBuildOrders), { pages: Object.assign(Object.assign({}, newBuildOrders.pages), { [pageId]: Object.assign(Object.assign({}, topNavBarPage), { topNavigationBar: newTopNavigationBar }) }) }),
                flattedControls: Object.assign(Object.assign({}, flattedControls), { [pageId]: Object.assign(Object.assign({}, pageInfo), { control: Object.assign(Object.assign({}, pageInfo.control), { topNavigationBar: newTopNavigationBar }) }), [controlId]: Object.assign(Object.assign({}, castedControlInfo), { control: newTopNavigationBar }) }),
            };
        }
        case 'pageTopNavControl': {
            const castedControlInfo = controlInfo;
            const { pageId } = castedControlInfo.context;
            const page = newBuildOrders.pages && newBuildOrders.pages[pageId];
            if (!page) {
                throw new Error('No page found');
            }
            const topNavbarControl = page.topNavigationBar;
            if (!topNavbarControl) {
                throw new Error('No top navbar controls');
            }
            const pageInfo = flattedControls[pageId];
            if (!pageInfo) {
                throw new Error('Page info not found');
            }
            const { topNavigationBar, updatedControls } = (0, updatePageTopNavControl_1.default)({
                topNavigationBar: topNavbarControl,
                controlInfo: castedControlInfo,
                dataToUpdate,
                shouldNotResetDynamicLoadingEnabled,
            });
            newBuildOrders.pages = Object.assign(Object.assign({}, newBuildOrders.pages), { [pageId]: Object.assign(Object.assign({}, page), { topNavigationBar }) });
            const newFlattedControls = (0, addUpdatedControlsToFlattedControls_1.default)(updatedControls, flattedControls);
            const newTopNavbarInfo = flattedControls[topNavigationBar.id];
            if (!newTopNavbarInfo) {
                throw new Error('No new top navbar info found');
            }
            return {
                buildOrders: newBuildOrders,
                flattedControls: Object.assign(Object.assign({}, newFlattedControls), { [pageId]: Object.assign(Object.assign({}, pageInfo), { control: Object.assign(Object.assign({}, pageInfo.control), { topNavigationBar }) }), [topNavigationBar.id]: Object.assign(Object.assign({}, newTopNavbarInfo), { control: topNavigationBar }) }),
            };
        }
        case 'pageSideMenuControl': {
            const castedControlInfo = controlInfo;
            const sideMenu = (_d = newBuildOrders.menus) === null || _d === void 0 ? void 0 : _d.sideMenu;
            if (!sideMenu) {
                throw new Error('No side menu found');
            }
            const { controls, updatedControls } = (0, updateControlsArrayByPath_1.default)({
                controls: sideMenu.controls || [],
                path: castedControlInfo.path,
                dataToUpdate,
                shouldNotResetDynamicLoadingEnabled,
            });
            const newSideMenu = Object.assign(Object.assign({}, sideMenu), { controls });
            const newFlattedControls = (0, addUpdatedControlsToFlattedControls_1.default)(updatedControls, flattedControls);
            const newSideMenuInfo = newFlattedControls[newSideMenu.id];
            if (!newSideMenuInfo) {
                throw new Error('No new side menu info founc');
            }
            return {
                buildOrders: Object.assign(Object.assign({}, newBuildOrders), { menus: Object.assign(Object.assign({}, newBuildOrders.menus), { sideMenu: newSideMenu }) }),
                flattedControls: Object.assign(Object.assign({}, newFlattedControls), { [newSideMenu.id]: Object.assign(Object.assign({}, newSideMenuInfo), { control: newSideMenu }) }),
            };
        }
        default:
            throw new Error('Invalid control context type');
    }
};
exports.default = updateControlById;
